
	import { defineComponent } from "vue";
    import NavBar from "@/components/NavBar.vue";
    import TileInfoGrid from "@/components/TileInfoGrid.vue";
    import { QuoteItem } from '@/domain/entities/Misc'

	export default defineComponent({
		components: {
			NavBar, TileInfoGrid,
		},
		setup() {
			let faqs : QuoteItem[] = [
				{ title: 'Información basíca sobre la COVID-19', link: 'https://www.who.int/es/news-room/q-a-detail/coronavirus-disease-covid-19' },
				{ title: 'Preguntas y respuestas sobre la COVID-19 y las mascarillas', link: 'https://www.who.int/es/news-room/q-a-detail/coronavirus-disease-covid-19-masks' },
				{ title: 'Preguntas y respuestas sobre la inocuidad de los alimentos y nutrición en relación con la COVID-19', message: "", link: 'https://www.who.int/es/news-room/q-a-detail/food-safety-and-nutrition' },
				{ title: 'Enfermedad por el coronavirus (COVID-19): Vacunas', link: "https://www.who.int/es/news-room/q-a-detail/coronavirus-disease-(covid-19)-vaccines" },
				{ title: 'Preguntas y respuestas sobre la evolución del SARS-CoV-2', link: "https://www.who.int/es/news-room/q-a-detail/coronavirus-disease-(covid-19)-vaccines" },
				{ title: 'Mas información', link: "https://www.who.int/es/news-room/q-a-detail" },
			];
			return {
				faqs,
			};
		},
	});
